import React, {Component} from 'react'

import {datasetSelector} from '../selectors'

import {connect} from 'react-redux'
import DatasetHome from '../components/DatasetHome'

let mapDispatchToProps = (dispatch) => ({})

let mapStateToProps = (state, ownProps) => ({
  dataset: datasetSelector(state),
  base_url: ownProps.base_url
})
let ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(DatasetHome)
export default ConnectedComponent


// WEBPACK FOOTER //
// ./src/containers/DatasetHome.js